import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { addHeaders } from '../../shared/utils/globalUtils';

export const landingApi = createApi({
    reducerPath: 'landingApi',
    baseQuery: fetchBaseQuery({ 
    baseUrl : 'http://localhost:8000/api',
    prepareHeaders: (headers) => {
        return addHeaders(headers);
    }
    }),
    endpoints: (builder) => ({
        getLandingByName: builder.query({
            query: () => ({
                url: '/lp',
                method: 'Get'
            })
        }),
    }),   

})

export const { useGetLandingByNameQuery } = landingApi;